import {postMethod} from '@/api'

export const post = request => postMethod('/api/massEditOrders', request)
